import { useEffect } from 'react';

/**
 * Scroll the page while something is being dragged near the top or bottom
 * of the window.
 *
 * Browsers barely auto-scroll during a native drag-and-drop, so moving photo
 * 12 to place 3 meant dropping it, scrolling, picking it up again. Within
 * EDGE px of an edge the page now scrolls, faster the closer to the edge.
 */
export const EDGE = 80;
export const MAX_SPEED = 22; // px per frame at the very edge

/** Scroll step for a pointer at `y` in a viewport `height` tall (negative = up). */
export function edgeSpeed(y, height, edge = EDGE, max = MAX_SPEED) {
  if (y < edge) return -Math.ceil(max * ((edge - Math.max(y, 0)) / edge));
  if (y > height - edge) return Math.ceil(max * ((Math.min(y, height) - (height - edge)) / edge));
  return 0;
}

export default function useDragAutoScroll(active) {
  useEffect(() => {
    if (!active) return undefined;
    let pointerY = null;
    let frame = null;

    const onDragOver = (e) => { pointerY = e.clientY; };
    const tick = () => {
      if (pointerY !== null) {
        const step = edgeSpeed(pointerY, window.innerHeight);
        if (step) window.scrollBy(0, step);
      }
      frame = window.requestAnimationFrame(tick);
    };

    // dragover keeps firing while the pointer rests, but not on every frame:
    // the loop runs on its own and reads the last position.
    document.addEventListener('dragover', onDragOver);
    frame = window.requestAnimationFrame(tick);
    return () => {
      document.removeEventListener('dragover', onDragOver);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [active]);
}
